<script>
import api from "@/api";

export default {
  data: function() {
    return {
      schedules: [],
      leagues: [],
      users: [],
    };
  },
  methods: {
    fetchData() {
      if (!this.isAdmin) {
        this.goRouter("/");
        return;
      }
      this.isLoading = true;
      api
        .getUsers()
        .then(response => {
          this.users = response.data.users;
          this.isLoading = false;
        })
        .catch(e => {
          console.log(e);
          this.isLoading = false;
        });
    },
  },
  mounted() {
    console.log("Admin Mounted");
    this.fetchData();
  },
};
</script>

<template>
  <div class="admin">
    <div class="p-grid">
      <!-- <div class="p-col-6">
        <h1> Users </h1>
        <table style="width: 100%; border-top: 1px solid grey">
          <tr>
            <th> ID </th> <th> Name </th> <th> Email </th>
          <tr v-for="u in users" :key="u.id" class="timeslotRow">
            <td class="p-text-left" style="width: 50%">
              {{ u.id}} 
            </td>
            <td class="p-text-left">
              {{ u.first }} {{u.last }}
            </td>
            <td class="p-text-left" >
              {{ u.email }}
            </td>
          </tr>
        </table>
      </div> -->
      <div class="p-col-12">
        <h1 class="title is-4">Users</h1>
        <table style="width: 100%;">
          <tr>
            <th>ID</th>
            <th>Created</th>
            <th>First</th>
            <th>Last</th>
            <th>Email</th>
            <th>Timezone</th>
            <th>Action</th>
          </tr>

          <tr v-for="s in users" :key="s.id" style="font-weight: normal">
            <td class="">{{ s.id }}</td>
            <td class="">{{ s.first }}</td>
            <td class="">{{ s.last }}</td>
            <td class="">{{ s.email }}</td>
            <td class="">{{ s.timezone }}</td>
            <td>
              <a :href="`${apiUrl}/we/hate/drop/shadows?email=${s.email}`">
                Login
              </a>
            </td>
          </tr>
        </table>
      </div>
      <!-- <div class="p-col-12">
        <h1 class="title is-4"> Schedules: {{schedules.length}} </h1>
        <table style="width: 100%;">
          <tr>
            <th> ID </th> <th> Created </th>  <th> Name </th> <th> Score </th> <th> Good </th> <th> Bad </th> <th> Status </th> 
          <tr v-for="s in schedules" :key="s.id">
            <td class="smallFont"> <a target="_blank" :href="`/schedules/${s.id}`"> {{ s.id }} </a> </td>
            <td class="smallFont"> {{ s.name }} </td>
            <td> {{ new Date(s.created_at).toLocaleString() }} </td>
            <td> {{ s.unscheduled > 0 ? s.scheduled.toFixed(2) / s.unscheduled.toFixed(2) : '100'}} </td>
            <td> {{ s.scheduled }} </td>
            <td> {{ s.unscheduled }} </td>
            <td> 
              <span v-if="s.finished">
                <span v-if="s.success">
                  SUCCESS 
                </span>
                <span v-else style="color: red; font-weight: bold">
                  {{ s.error_message }}
                </span>
              </span>
              <span v-else style="color: orange">
                IN PROGRESS
              </span>
            </td>
          </tr>
        </table>
      </div> -->
    </div>
  </div>
</template>

<style lang="scss">
.admin {
  td {
    text-align: left !important;
  }

  th {
    text-align: left !important;
  }
  .smallFont {
    font-size: 10px;
  }

  div {
    user-select: text !important;
  }
}
</style>
